import React from 'react';
import { Card } from '../../components/ui/card';
import { BookOpen } from 'lucide-react';

const Research = () => {
  return (
    <div className="space-y-8 animate-fadeIn">
      <div>
        <h1 className="text-4xl font-bold text-black mb-2">Research</h1>
        <p className="text-gray-600">Market insights and analysis</p>
      </div>

      <Card className="p-6">
        <div className="flex items-center justify-center py-20">
          <div className="text-center">
            <BookOpen className="w-16 h-16 text-gray-600 mx-auto mb-4" />
            <p className="text-gray-500 text-lg">Research center coming soon</p>
            <p className="text-gray-600 text-sm mt-2">Market analysis, reports, and educational content</p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Research;